// The one bundle. A single script tag in Webflow's site-wide footer loads this
// on every page, and this file decides what runs where.
//
//   Site settings -> Custom code -> Footer code
//   a single <script src> pointing at .../tdp26/main/index_bundle.min.js
//
// Nothing else is ever pasted into Webflow. To give a page its own code, add it
// to PAGES below -- that is the only wiring step.
import { initGlobal } from './pages/global.js';
import { initHome } from './pages/home.js';

// Webflow page path -> the code for that page. Home is '/'.
//
//   '/about':  initAbout      exact match
//   '/work/*': initWorkDetail trailing /* matches that path and everything under
//                             it, for CMS collection pages
const PAGES = {
  '/': initHome,
};

// Trailing slashes and casing vary between Webflow's editor, the staging domain
// and production, so normalise before matching.
function currentPath() {
  return (location.pathname.replace(/\/+$/, '') || '/').toLowerCase();
}

function pageFor(path) {
  if (PAGES[path]) return PAGES[path];
  for (const [pattern, init] of Object.entries(PAGES)) {
    if (pattern.endsWith('/*') && path.startsWith(pattern.slice(0, -1))) return init;
  }
  return null;
}

initGlobal();

const page = pageFor(currentPath());
if (page) page();
